import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "49.408",
  width: "50",
  viewBox: "0 0 50 49.408",
  ...extra,
  children: [title, /*#__PURE__*/_jsxs("g", {
    fill: "#ef0000",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M49.405.856c2.736 2.735-4.787 14.36-5.926 15.5-1.14 1.14-4.34 0-7.07-2.508-2.74-2.735-3.88-5.926-2.51-7.066C35.27 5.414 46.89-1.88 49.4.855zM12.25 3.59C8.147 1.31 2.448-1.195.624.63c-1.824 1.82.684 7.748 3.192 11.85 2.05-3.647 4.787-6.61 8.434-8.89z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M45.53 15.444c.456 1.368.228 2.28-.228 2.963-1.368 1.368-5.243 0-8.662-3.42l-.684-.683c-1.14-1.14-2.28-2.507-2.735-3.875-1.14-2.28-1.59-4.11-.68-5.02.46-.46 1.37-.69 2.28-.46.69-.46 1.37-.918 2.28-1.37-3.65-1.59-7.52-2.5-11.4-2.5-13.45 0-24.16 10.71-24.16 24.16 0 13.22 10.72 24.16 24.168 24.16 13.22 0 24.16-10.715 24.16-24.163 0-4.33-1.14-8.433-3.19-11.852-.458.69-.914 1.37-1.14 2.05z"
    })]
  })]
});